import * as React from "react";
import {
  Button,
  FormGroup,
  Label,
  Input,
  CustomInput,
  Row,
  Col
} from "reactstrap";
import MaskedInput from 'react-text-mask'
import { connect } from "react-redux";
import Header from "./Header";
import { FormStep, Step } from "../../store/application/applicationState";
import { RootState } from "../../store";
import {
  ApplicationAction,
  setCoContactInformation,
  gotoStep
} from "../../store/application/applicationActions";
import { FullNameAttribute } from "../../models/fullnameattribute";
import { CPRAttribute } from "../../models/cprattribute";
import { EmailAttribute } from "../../models/emailattribute";
import ApplicationContent from "../applicationContent";
import ApplicationFooter from "../applicationFooter";

interface StepCoappliantState {
  dirty: boolean;
  name?: string;
  cpr?: string;
  email?: string;
}

type Props = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;

class StepCoappliant extends React.Component<Props, StepCoappliantState> {
  constructor(props: Props) {
    super(props);

    this.state = {
      dirty: false,
      name: props.application.data.coname,
      email: props.application.data.coemail,
      cpr: props.application.data.cocpr
    };

    this.next = this.next.bind(this);
  }

  next(): void {
    this.setState({ dirty: true });
    const nameValid = !FullNameAttribute.hasError(this.state.name);
    const cprValid = !CPRAttribute.hasError(this.state.cpr);
    const emailValid = !EmailAttribute.hasError(this.state.email);
    if (nameValid && cprValid && emailValid) {
      //all good.
      this.props.setCoContactInformation(
        this.state.name,
        this.state.cpr,
        this.state.email
      );
    }
  }

  render() {
    return (
      <div>
            <Header formStep={FormStep.Other} step={Step.CoappliantContact} />
        <ApplicationContent>
          <FormGroup>
            <Label for="coname" className="text-uppercase font-weight-bold">
              Navn på medansøger
            </Label>
            <Input
              className={
                this.state.dirty && FullNameAttribute.hasError(this.state.name)
                  ? "is-invalid"
                  : ""
              }
              type="text"
              id="coname"
              name="coname"
              placeholder="Medansøgers fulde navn"
              value={this.state.name || ""}
              onChange={event => this.setState({ name: event.target.value })}
            />
            {this.state.dirty &&
              FullNameAttribute.hasError(this.state.name) && (
                <div className="invalid-feedback">
                  {FullNameAttribute.getErrorMessage()}
                </div>
              )}
          </FormGroup>

          <FormGroup>
            <Label for="coemail" className="text-uppercase font-weight-bold">
              Medansøgers email
            </Label>
            <Input
              className={
                this.state.dirty && EmailAttribute.hasError(this.state.email)
                  ? "is-invalid"
                  : ""
              }
              type="email"
              id="coemail"
              name="coemail"
              placeholder="Indtast medansøgers email"
              value={this.state.email || ""}
              onChange={event => this.setState({ email: event.target.value })}
            />
            {this.state.dirty && EmailAttribute.hasError(this.state.email) && (
              <div className="invalid-feedback">
                {EmailAttribute.getErrorMessage()}
              </div>
            )}
          </FormGroup>

          <FormGroup>
            <Label for="cocpr" className="text-uppercase font-weight-bold">
              Medansøgers CPR nr.
            </Label>
                    <MaskedInput

                        mask={[/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                        className={
                            this.state.dirty && CPRAttribute.hasError(this.state.cpr)
                                ? "is-invalid cpr form-control"
                                : "cpr form-control"
                        }
                        type="text"
                        id="cocpr"
                        name="cocpr"
                        inputmode="numeric"
                        placeholder="Indtast medansøgers CPR nr.."
                        value={this.state.cpr}
                        onChange={event => this.setState({ cpr: event.target.value })}
                    />


         
            {this.state.dirty && CPRAttribute.hasError(this.state.cpr) && (
              <div className="invalid-feedback">
                {CPRAttribute.getErrorMessage()}
              </div>
            )}
          </FormGroup>

          <br />
        </ApplicationContent>
        <ApplicationFooter>
          <Row className="mt-2">
            <Col className="col-12 text-right">
              <Button
                className="back"
                onClick={() => this.props.gotoStep(Step.Coappliant)}
              >
                Tilbage
              </Button>
              <Button className="next" onClick={this.next}>
                Næste
              </Button>
            </Col>
          </Row>
        </ApplicationFooter>
      </div>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  application: state.applicationState
});

const mapDispatchToProps = (dispatch: (action: ApplicationAction) => void) => ({
  setCoContactInformation: (name: string, cpr: string, email: string) =>
    dispatch(setCoContactInformation(name, cpr, email)),
  gotoStep: (step: Step) => dispatch(gotoStep(step))
});

export default connect(mapStateToProps, mapDispatchToProps)(StepCoappliant);
